import React, { useState, useEffect, useCallback } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ArModal from "../../../components/Modal/ArModal";
import SoModal from "../../../components/Modal/SoModal";
import FormAction from "../../../components/Actions/FormAction";
import PaymentModal from "../../../components/Modal/PaymentModal";
import ViewSoModal from "../../../components/Modal/ViewSoModal";
import DatePicker from "../../../components/DatePicker";

// Model
import { biMasterModel } from "../../../../model/SellProducts/BiMasterModel";
import { biDetailModel } from "../../../../model/SellProducts/BiDetailModel";

import {
  getData,
  getDataByQuery,
  getDataWithComp,
  formatCurrency,
  parseCurrency,
  getAlert,
  deleteData,
  randomDelay,
  createSetRecNo,
  getMaxRecNoForTest,
  uploadSlip,
  uploadMultipleSlips,
  getSpRunNumber,
} from "../../../../utils/SamuiUtils";

import {
  formatThaiDateUiToDate,
  setCreateDateTime,
  getCreateDateTime,
  formatDate,
} from "../../../../utils/DateUtils";

import { InvoiceHandleSubmit } from "../../../../utils/InvoiceUtils";
import {
  manageWhArPaymentData,
  setRemarkByPaymentType,
} from "../../../../utils/PaymentUtils";

const Form = ({ callInitialize, mode, setMode, name, docNo, getReport }) => {
  const [formMasterList, setFormMasterList] = useState(biMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [soDataList, setSoDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);

  // การแสดงสถานะเอกสาร
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");
  const [statusPaidName, setStatusPaidName] = useState("");
  const [statusPaidColour, setStatusPaidColour] = useState("");
  const [statusPaidTypeName, setStatusPaidTypeName] = useState("");
  const [statusPaidTypeColour, setStatusPaidTypeColour] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = React.useState(false);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  // subFinal removed; SO net total (soNetTotal) is used as base for final calculations
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // สำหรับเก็บประเภทการชำระเงิน
  const [paymentType, setPaymentType] = useState({});
  const [paymentAmount, setPaymentAmount] = useState({});
  const [payDatetime, setPayDatetime] = useState(moment());

  // เก็บตัวแปรสำหรับเช็ค
  const [chequeNo, setChequeNo] = useState("");
  const [chequeName, setChequeName] = useState("");
  const [chequeBranch, setChequeBranch] = useState("");
  const [chequeDate, setChequeDate] = useState(moment());

  // เก็บตัวแปรสำหรับธนาคาร
  const [bankMasterId, setBankMasterId] = useState("2");
  const [bankId, setBankId] = useState("");
  const [bankInputMode, setBankInputMode] = useState("select"); // "select" หรือ "manual"
  const [payToAccNo, setPayToAccNo] = useState("");
  const [payToAccName, setPayToAccName] = useState("");

  const [base64Image, setBase64Image] = useState("");

  // ใช้สำหรับคำนวณยอดรวมใหม่ที่ตาราง
  const [soTotal, setSoTotal] = useState(0);
  const [soTotalVat, setSoTotalVat] = useState(0);
  const [soNetTotal, setSoNetTotal] = useState(0);

  // State for SO remove confirmation modal
  const [showConfirmRemoveSo, setShowConfirmRemoveSo] = useState(false);
  const [removeSoIndex, setRemoveSoIndex] = useState(null);

  // สำหรับเก็บสลิป
  const [slipImage, setSlipImage] = useState("");
  const [multipleSlipImages, setMultipleSlipImages] = useState([]);
  const [isUploadingSlips, setIsUploadingSlips] = useState(false);
  const [otherRemark, setOtherRemark] = useState("");




  // getModelByNo implementation moved earlier to satisfy hook ordering

  const initialize = useCallback(async () => {
    setIsLoading(true);
    try {
      const compId = Number(window.localStorage.getItem("company"));
      const arDataList = await getDataByQuery(`
        SELECT
          AR_Id,
          AR_Code,
          AR_Name,
          AR_Add1,
          AR_Add2,
          AR_Add3,
          AR_Province,
          AR_Zipcode,
          AR_TaxNo
        FROM Tb_Set_AR
        WHERE Comp_Id = ${compId}
        ORDER BY AR_Code ASC
      `);
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      // Default จำนวนการชำระไว้ก่อนเป็น 0.00
      setPaymentAmount({
        cash: "0.00",
        transfer: "0.00",
        cheque: "0.00",
        fee: "0.00",
        other: "0.00",
      });

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(arDataList);
      }
    } catch (err) {
      getAlert("FAILED", err.message || err);
    } finally {
      setIsLoading(false);
    }
  }, [mode]);

  useEffect(() => {
    initialize();
  }, [initialize]);

  const handleMultipleSlipUpload = useCallback(
    (event) => {
      const files = Array.from(event.target.files);
      if (files.length === 0) {
        event.target.value = "";
        return;
      }
      if (multipleSlipImages.length + files.length > 100) {
        getAlert("FAILED", "ไม่สามารถอัพโหลดได้เกิน 100 ไฟล์");
        event.target.value = "";
        return;
      }
      setIsUploadingSlips(true);
      const newImages = [];
      let processedCount = 0;
      let hasErrors = false;
      files.forEach((file, index) => {
        if (file.size > 5 * 1024 * 1024) {
          getAlert("FAILED", `ไฟล์ ${file.name} มีขนาดใหญ่เกินไป (เกิน 5MB)`);
          hasErrors = true;
          processedCount++;
          if (processedCount === files.length) {
            setIsUploadingSlips(false);
            event.target.value = "";
          }
          return;
        }
        const allowedTypes = [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "image/gif",
        ];
        if (!allowedTypes.includes(file.type)) {
          getAlert("FAILED", `ไฟล์ ${file.name} ไม่ใช่รูปภาพที่รองรับ`);
          hasErrors = true;
          processedCount++;
          if (processedCount === files.length) {
            setIsUploadingSlips(false);
            event.target.value = "";
          }
          return;
        }
        const reader = new FileReader();
        reader.onloadend = () => {
          const isDuplicate = multipleSlipImages.some(
            (existingImg) =>
              existingImg.name === file.name && existingImg.size === file.size
          );
          if (!isDuplicate) {
            newImages.push({
              id: `${file.name}-${file.size}-${Date.now()}-${index}`,
              name: file.name,
              base64: reader.result,
              type: file.type,
              size: file.size,
            });
          }
          processedCount++;
          if (processedCount === files.length) {
            setMultipleSlipImages((prev) => [...prev, ...newImages]);
            setIsUploadingSlips(false);
            if (newImages.length > 0) {
              getAlert("OK", `เพิ่มสลิป ${newImages.length} ไฟล์เรียบร้อยแล้ว`);
            } else if (!hasErrors) {
              getAlert("FAILED", "ไฟล์ที่เลือกมีอยู่แล้วทั้งหมด");
            }
            event.target.value = "";
          }
        };
        reader.onerror = () => {
          getAlert("FAILED", `เกิดข้อผิดพลาดในการอ่านไฟล์ ${file.name}`);
          hasErrors = true;
          processedCount++;
          if (processedCount === files.length) {
            setIsUploadingSlips(false);
            event.target.value = "";
          }
        };
        reader.readAsDataURL(file);
      });
    },
    [multipleSlipImages, setMultipleSlipImages, setIsUploadingSlips]
  );

  const handleRemoveSlipImage = (imageId) => {
    setMultipleSlipImages((prev) => prev.filter((img) => img.id !== imageId));
  };

  const handleClearAllSlips = () => {
    setMultipleSlipImages([]);
    getAlert("OK", "ลบสลิปทั้งหมดเรียบร้อยแล้ว");
  };

  const getModelByNo = useCallback(async (arDataList) => {
    setIsLoading(true);
    try {
      const fromDatabase = await getDataWithComp(
        "API_1301_BL_H",
        `AND Doc_No = '${docNo}'`
      );

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase[0].AR_ID
      );

      if (!fromViewAr) {
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      setStatusPaidName(fromDatabase[0].DocBLStatusPaid_Name);
      setStatusPaidColour(fromDatabase[0].DocBLStatusPaid_Colour);
      const docStatusPaidType = Number(fromDatabase[0].Doc_Status_Paid_Type);
      setStatusPaidTypeName(
        docStatusPaidType === 4 ? "ค่าธรรมเนียม" : (fromDatabase[0].DocStatusPaid_Type_Name || "")
      );
      setStatusPaidTypeColour(fromDatabase[0].DocBLStatusPaid_Colour);

      // รอพี่คินทำ View ให้ ตอนนี้ Mock ไปก่อน
      if (fromDatabase[0].Doc_Status === 1) {
        setStatusName("รออนุมัติ");
        setStatusColour("#EAA300");
      } else if (fromDatabase[0].Doc_Status === 2) {
        setStatusName("อนุมัติ");
        setStatusColour("#13A10E");
      } else if (fromDatabase[0].Doc_Status === 5) {
        setStatusName("ปิดงาน");
        setStatusColour("rgb(128, 128, 128)");
      } else if (fromDatabase[0].Doc_Status === 13) {
        setStatusName("ยกเลิก");
        setStatusColour("#000000");
        setStatusPaidName("");
        setStatusPaidColour("");
        setStatusPaidTypeName("");
        setStatusPaidTypeColour("");
      }

      // ค้นหาข้อมูลของ Detail ด้วย Doc_Id
      const fromDetail = await getData(
        "API_1302_BL_D",
        `Doc_Id = ${fromDatabase[0].Doc_Id}`
      );

      if (!fromDetail || fromDetail.length === 0) {
        throw new Error("ไม่พบข้อมูลรายละเอียดเอกสาร");
      }

      // ใช้ Promise.all เพื่อโหลดข้อมูล SO พร้อมกัน
      const soDataResults = await Promise.all(
        fromDetail.map((detail) =>
          getData("API_0701_SO_H", `Doc_ID = ${detail.SO_Id}`)
        )
      );

      const processedSoData = [];
      let soTotal = 0;
      let soTotalVat = 0;
      let soNetTotal = 0;

      // ใช้ flatMap() เพื่อให้แน่ใจว่า soDataResults ไม่ใช่อาร์เรย์ซ้อน
      await Promise.all(
        soDataResults
          .flatMap((dataArray) => dataArray)
          .map(async (fromViewSo) => {
            if (fromViewSo) {
              // ✅ ต้องแน่ใจว่า push ถูกต้อง (ไม่ push อาร์เรย์ซ้อน)
              processedSoData.push({
                soId: fromViewSo.Doc_ID,
                soNo: fromViewSo.Doc_No,
                soDocDate: fromViewSo.Doc_Date,
                arName: fromViewSo.AR_Name,
                itemTotal: parseCurrency(fromViewSo.Total_Before_Vat) || 0,
                totalVat: parseCurrency(fromViewSo.VAT) || 0,
                netTotal: parseCurrency(fromViewSo.NetTotal) || 0,
              });

              // ✅ คำนวณค่ารวม
              soTotal += parseCurrency(fromViewSo.Total_Before_Vat) || 0;
              soTotalVat += parseCurrency(fromViewSo.VAT) || 0;
              soNetTotal += parseCurrency(fromViewSo.NetTotal) || 0;
            }
          })
      );

      // เซ็ตข้อมูลรายละเอียดจาก SO ที่ดึงมาจากฐานข้อมูล
      // (ไม่เรียก onRowSelectSo อีกครั้ง เพื่อหลีกเลี่ยงการประมวลผลซ้ำ)
      setSoTotal(soTotal);
      setSoTotalVat(soTotalVat);
      setSoNetTotal(soNetTotal);
      setFormDetailList(processedSoData);

      const data = fromDatabase[0];
      setIsVatChecked(data.BL_Is_Vat === 1);

      // โหลด BL_Service_Charge จาก BL_H โดยตรง (กรณี View API_1301_BL_H ไม่มีคอลัมน์นี้)
      let blServiceChargeValue = data.BL_Service_Charge;
      if (blServiceChargeValue == null || blServiceChargeValue === "") {
        const blHRow = await getData("BL_H", `Doc_Id = ${data.Doc_Id}`);
        blServiceChargeValue = blHRow?.[0]?.BL_Service_Charge ?? 0;
      }

      setFormMasterList({
        docId: data.Doc_Id,
        compId: data.Comp_Id,
        docNo: data.Doc_No,
        docDate: data.Doc_Date || null,
        docDueDate: data.Doc_Due_Date || null,
        docStatus: data.Doc_Status,
        docPaidStatus: data.Doc_Paid_Status,
        arID: data.AR_ID,
        arCode: data.AR_Code,
        arName: data.AR_Name,
        createdDate: setCreateDateTime(data.Created_Date),
        createdByName: data.Created_By_Name,
        createdById: data.Created_By_Id,
        updateDate: getCreateDateTime(),
        updateByName: window.localStorage.getItem("name"),
        updateById: window.localStorage.getItem("emp_id"),
        cancelDate: setCreateDateTime(data.Cancel_Date),
        cancelByName: data.Cancel_By_Name,
        cancelById: data.Cancel_By_Id,
        blTotal: data.BL_Total,
        blDis: data.BL_Dis,
        blIsVat: data.BL_Is_Vat,
        blVat: data.BL_Vat,
        blNetTotal: data.BL_Net_Total,
        docIsInv: data.Doc_Is_INV,
        docInvNo: data.Doc_INV_No,
        docIsInvFrom: data.Doc_Is_INV_From,
        discountValue: data.Discount_Value,
        discountValueType: data.Discount_Value_Type,
        docStatusPaidType: data.Doc_Status_Paid_Type,
        docRemark1: data.Doc_Remark1,
        docRemark2: data.Doc_Remark2,
        doc_bl_receive_date: data.Doc_BL_Receive_Date || null,
        payTotal: data.Pay_Total,
        blServiceCharge: blServiceChargeValue != null ? blServiceChargeValue : 0,
        arAdd1: fromViewAr.AR_Add1,
        arAdd2: fromViewAr.AR_Add2,
        arAdd3: fromViewAr.AR_Add3,
        arProvince: fromViewAr.AR_Province,
        arZipcode: fromViewAr.AR_Zipcode,
        arTaxNo: fromViewAr.AR_TaxNo,
      });

      const loadedDis = parseCurrency(data.BL_Dis) || 0;
      const computedNetTotal = parseFloat((soNetTotal - loadedDis).toFixed(2));

      setTotalPrice(soNetTotal);
      setReceiptDiscount(loadedDis);
      setVatAmount(soTotalVat);
      setGrandTotal(computedNetTotal);

      // ค้นหารูปสลิปกรณีที่เป็นโอน
      const fromSlip = await getData(
        "Upload_File_List",
        `DocCode_Id = 14 AND Doc_ID = ${data.Doc_Id}`
      );
      if (fromSlip && fromSlip.length > 0) {
        setSlipImage(fromSlip[0].File_Url);
      }

      // กำหนดประเภทการจ่ายต่อ กรณีที่ค้างจ่าย
      if (Number(data.Doc_Paid_Status) === 1) {
        const payHistory = await getData(
          "Pay_History",
          `DocCode_Id = 14 AND Pay_Type = ${fromDatabase.Doc_Status_Paid_Type} AND Doc_Id = ${fromDatabase.Doc_Id}`
        );
        if (payHistory && payHistory.length > 0) {
          setPayDatetime(moment(payHistory[0].Pay_Datetime));
        }

        switch (data.Doc_Status_Paid_Type) {
          // ถ้าเป็น 1 คือ เงินสด
          case 1:
            setPaymentType({
              cash: true,
              transfer: false,
              cheque: false,
              fee: false,
              other: false,
            });
            setPaymentAmount({
              cash: formatCurrency(data.Pay_Total),
              transfer: "0.00",
              cheque: "0.00",
              fee: "0.00",
              other: "0.00",
            });
            break;

          // ถ้าเป็น 2 คือ เงินโอน
          case 2:
            setPaymentType({
              cash: false,
              transfer: true,
              cheque: false,
              fee: false,
              other: false,
            });
            setPaymentAmount({
              cash: "0.00",
              transfer: formatCurrency(data.Pay_Total),
              cheque: "0.00",
              fee: "0.00",
              other: "0.00",
            });
            break;

          // ถ้าเป็น 3 คือ เช็ค
          case 3:
            setPaymentType({
              cash: false,
              transfer: false,
              cheque: true,
              fee: false,
              other: false,
            });
            setPaymentAmount({
              cash: "0.00",
              transfer: "0.00",
              cheque: formatCurrency(data.Pay_Total),
              fee: "0.00",
              other: "0.00",
            });

            const payHistoryForCheque = await getData(
              "Pay_History",
              `DocCode_Id = 14 AND Pay_Type = 3 AND Doc_Id = ${fromDatabase.Doc_Id}`
            );
            if (payHistoryForCheque && payHistoryForCheque.length > 0) {
              const payData = payHistoryForCheque[0];
              setChequeNo(payData.Pay_Cheque_No);
              setChequeName(payData.Pay_Cheque_Name);
              setChequeBranch(payData.Pay_Cheque_Branch);
              setChequeDate(
                moment(payData.Pay_Cheque_date)
                  .add(543, "years")
                  .format("DD/MM/YYYY")
              );
            }

            break;

          // ถ้าเป็น 4 คือ ค่าธรรมเนียม
          case 4:
            setPaymentType({
              cash: false,
              transfer: false,
              cheque: false,
              fee: true,
              other: false,
            });
            setPaymentAmount({
              cash: "0.00",
              transfer: "0.00",
              cheque: "0.00",
              fee: formatCurrency(data.Pay_Total),
              other: "0.00",
            });
            break;

          // ถ้าเป็น 8 คือ อื่นๆ ระบุ
          case 8:
            setPaymentType({
              cash: false,
              transfer: false,
              cheque: false,
              fee: false,
              other: true,
            });
            setPaymentAmount({
              cash: "0.00",
              transfer: "0.00",
              cheque: "0.00",
              fee: "0.00",
              other: formatCurrency(data.Pay_Total),
            });
            const payHistoryOther = await getData(
              "Pay_History",
              `DocCode_Id = 14 AND Pay_Type = 8 AND Doc_Id = ${fromDatabase.Doc_Id}`
            );
            if (payHistoryOther && payHistoryOther.length > 0 && payHistoryOther[0].Pay_Remark) {
              setOtherRemark(payHistoryOther[0].Pay_Remark);
            }
            break;

          // ถ้าเป็น 6 แปลว่าจ่ายหลายช่องทาง ต้องไปค้นหาที่ Table : Pay_History เพิ่ม
          case 6:
            setPaymentType({
              cash: false,
              transfer: false,
              cheque: false,
              fee: false,
              other: false,
            });
            setPaymentAmount({
              cash: "0.00",
              transfer: "0.00",
              cheque: "0.00",
              fee: "0.00",
              other: "0.00",
            });
            const paymentHistoryResponse = await getData(
              "Pay_History",
              `DocCode_Id = 14 AND Doc_Id = ${fromDatabase[0].Doc_Id}`
            );
            if (paymentHistoryResponse && paymentHistoryResponse.length > 0) {
              // Loop ผ่านข้อมูลการจ่ายหลายช่องทาง
              for (const payment of paymentHistoryResponse) {
                switch (payment.Pay_Type) {
                  // ถ้า payment.Pay_Type === 1 คือ เงินสด
                  case 1:
                    setPaymentType((prev) => ({
                      ...prev,
                      cash: true,
                    }));
                    setPaymentAmount((prev) => ({
                      ...prev,
                      cash: formatCurrency(payment.Pay_Amount),
                    }));
                    break;

                  // ถ้า payment.Pay_Type === 2 คือ เงินโอน
                  case 2:
                    setPaymentType((prev) => ({
                      ...prev,
                      transfer: true,
                    }));
                    setPaymentAmount((prev) => ({
                      ...prev,
                      transfer: formatCurrency(payment.Pay_Amount),
                    }));
                    break;

                  // ถ้า payment.Pay_Type === 3 คือ เช็ค
                  case 3:
                    setPaymentType((prev) => ({
                      ...prev,
                      cheque: true,
                    }));
                    setPaymentAmount((prev) => ({
                      ...prev,
                      cheque: formatCurrency(payment.Pay_Amount),
                    }));

                    // ถ้าเป็นเช็ค ต้องเซ็ทเลขที่เช็ค ชื่อ และ วันที่แบบนี้ด้วย
                    setChequeNo(payment.Pay_Cheque_No);
                    setChequeName(payment.Pay_Cheque_Name);
                    setChequeBranch(payment.Pay_Cheque_Branch);
                    setChequeDate(
                      moment(payment.Pay_Cheque_date)
                        .add(543, "years")
                        .format("DD/MM/YYYY")
                    );
                    break;

                  // ถ้า payment.Pay_Type === 4 คือ ค่าธรรมเนียม
                  case 4:
                    setPaymentType((prev) => ({
                      ...prev,
                      fee: true,
                    }));
                    setPaymentAmount((prev) => ({
                      ...prev,
                      fee: formatCurrency(payment.Pay_Amount),
                    }));
                    break;

                  case 8:
                    setPaymentType((prev) => ({
                      ...prev,
                      other: true,
                    }));
                    setPaymentAmount((prev) => ({
                      ...prev,
                      other: formatCurrency(payment.Pay_Amount),
                    }));
                    if (payment.Pay_Remark) setOtherRemark(payment.Pay_Remark);
                    break;

                  // กรณีที่ไม่ตรงกับ 1, 2, 3, 4 หรือ 8
                  default:
                    console.warn(
                      `พบประเภทการจ่ายที่ไม่รู้จัก: ${payment.Pay_Type}`
                    );
                    break;
                }
              }
            }
            break;

          // กรณีอื่นๆ ถ้ามี
          default:
            console.log("ประเภทการจ่ายไม่ถูกต้อง");
            break;
        }

        // โหลดค่าธรรมเนียมจาก BL_H.BL_Service_Charge (ใช้จาก View หรือจาก BL_H โดยตรง)
        const feeFromBL = blServiceChargeValue != null ? parseCurrency(blServiceChargeValue) : 0;
        if (feeFromBL > 0) {
          setPaymentType((prev) => ({ ...prev, fee: true }));
          setPaymentAmount((prev) => ({ ...prev, fee: formatCurrency(blServiceChargeValue) }));
        }
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    } finally {
      setIsLoading(false);
    }
  }, [docNo]);

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  // ส่วนของ handleUpdateSlip ที่แก้ไขแล้ว
  const handleUpdateSlip = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบว่ามีการเลือกไฟล์หรือไม่
      if (!base64Image) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกไฟล์สลิปก่อนอัปโหลด");
        return;
      }

      // ทำการ Upload File รูปสลิป
      await uploadSlip(base64Image, formMasterList.docId, 14);

      await callInitialize();

      getAlert("OK", "อัพโหลดสลิปเรียบร้อยแล้ว");

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Upload error:", error);
      getAlert(
        "FAILED",
        error.response?.data?.message ||
        error.message ||
        "เกิดข้อผิดพลาดในการอัปโหลด"
      );
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? value.format("YYYY-MM-DD") : null,
    }));
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
      });

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET SO
  const [showSoModal, setShowSoModal] = useState(false);
  const handleSoShow = async () => {
    setIsLoading(true);
    try {
      let soDataList;

      // สร้างเงื่อนไขที่ต้องการสำหรับการดึงข้อมูล
      const condition = `
      AND Doc_Status_Paid_Type = '4'
      AND Doc_Status_Paid = '2'
      AND Doc_Status <> '13'
    `;

      if (mode === "U") {
        soDataList = await getDataWithComp(
          "API_0701_SO_H",
          `${condition} AND (Doc_BL_No IS NULL OR Doc_BL_No = '${docNo}') ORDER BY Doc_No DESC`
        );
      } else {
        soDataList = await getDataWithComp(
          "API_0701_SO_H",
          `${condition} AND Doc_BL_No IS NULL ORDER BY Doc_No DESC`
        );
      }

      // Filter out SOs already in formDetailList before displaying in modal
      if (soDataList && soDataList.length > 0) {
        const filteredSoDataList = soDataList.filter(
          (so) => !formDetailList.some((item) => item.soNo === so.Doc_No)
        );
        setSoDataList(filteredSoDataList);
      }

      setShowSoModal(true);
    } catch (err) {
      getAlert("FAILED", err.message || err);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSoClose = () => setShowSoModal(false);
  const onRowSelectSo = async (soSelected) => {
    setIsLoading(true);
    try {
      if (!Array.isArray(soSelected)) return;

      // เคลียร์ค่า VAT ด้วย
      setIsVatChecked(false);

      const createNewRow = (index, itemSelected) => {
        let netTotal = parseCurrency(itemSelected.NetTotal) || 0;
        let itemTotal = itemSelected.IsVat === 1 ? netTotal / 1.07 : netTotal;
        let totalVat = itemSelected.IsVat === 1 ? netTotal - itemTotal : 0.0;
        if (totalVat > 0) {
          setIsVatChecked(true);
        } else {
          setIsVatChecked(false);
        }
        return {
          ...biDetailModel(index + 1),
          soId: itemSelected.Doc_ID,
          soNo: itemSelected.Doc_No,
          soDocDate: itemSelected.Doc_Date,
          arName: itemSelected.AR_Name,
          remark: itemSelected.Doc_Remark1,
          itemTotal: formatCurrency(itemTotal),
          netTotal: formatCurrency(netTotal),
          totalVat: formatCurrency(totalVat),
        };
      };

      const newFormDetails = soSelected.map((item, index) =>
        createNewRow(formDetailList.length + index, item)
      );
      // คำนวณเงินยอดรวม
      let soTotal = 0;
      let soTotalVat = 0;
      let soNetTotal = 0;

      for (const soData of soSelected) {
        soTotal += parseCurrency(soData.Total_Before_Vat) || 0;
        soTotalVat += parseCurrency(soData.VAT) || 0;
        soNetTotal += parseCurrency(soData.NetTotal) || 0;
      }

      setSoTotal(soTotal);
      setSoTotalVat(soTotalVat);
      setSoNetTotal(soNetTotal);

      setFormDetailList((prev) => [...prev, ...newFormDetails]);
      setSoDataList((prev) => [...prev, ...soSelected]);
    } catch (error) {
      getAlert("FAILED", error.message || error);
    } finally {
      setIsLoading(false);
    }
  };
  const onConfirmSoSelection = async (soSelected) => {
    const hasVat = soSelected.some((so) => so.IsVat === 1);
    const hasNoVat = soSelected.some((so) => so.IsVat === 2);

    if (hasVat && hasNoVat) {
      getAlert(
        "FAILED",
        "ไม่สามารถเลือกใบขายสินค้าที่มี VAT และไม่มี VAT ร่วมกันได้"
      );
      return;
    }

    onRowSelectSo(soSelected);
    handleSoClose();
    getAlert("OK", "การเลือกใบขายสินค้าสำเร็จ");
  };
  const handleRemoveSo = (index) => {
    // Remove item from formDetailList and also recalculate SO totals
    const newFormDetailList = [...formDetailList];
    const removed = newFormDetailList.splice(index, 1);

    // Update formDetailList
    setFormDetailList(newFormDetailList);

    // Also remove corresponding entry from soDataList if present (match by soId or soNo)
    if (removed && removed.length > 0) {
      const rem = removed[0];
      setSoDataList((prev) =>
        prev.filter((s) => !(s.Doc_ID === rem.soId || s.Doc_No === rem.soNo))
      );
    }

    // Recalculate SO totals from the remaining details
    const totals = newFormDetailList.reduce(
      (acc, item) => {
        acc.soTotal += parseCurrency(item.itemTotal) || 0;
        acc.soTotalVat += parseCurrency(item.totalVat) || 0;
        acc.soNetTotal += parseCurrency(item.netTotal) || 0;
        return acc;
      },
      { soTotal: 0, soTotalVat: 0, soNetTotal: 0 }
    );

    setSoTotal(totals.soTotal);
    setSoTotalVat(totals.soTotalVat);
    setSoNetTotal(totals.soNetTotal);
  };

  const handleSubmit = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดใบขาย");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: await getSpRunNumber("BI"),
        doc_date: formMasterList.docDate,
        doc_due_date: formMasterList.docDueDate,
        doc_status: 1,
        doc_paid_status: 0,
        ar_id: formMasterList.arID,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        bl_total: parseCurrency(soNetTotal ?? totalPrice) || 0,
        bl_dis: receiptDiscount,
        bl_is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
        bl_vat: parseCurrency(soTotalVat ?? vatAmount) || 0,
        bl_net_total: parseCurrency(grandTotal) || 0,
        doc_is_inv: parseCurrency("0"),
        doc_inv_no: null,
        doc_is_inv_from: null,
        discount_value: parseCurrency(formMasterList.discountValue || 0),
        discount_type: parseCurrency(selectedDiscountValueType),
        doc_status_paid_type: null,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        doc_bl_receive_date: null,
        pay_total: parseCurrency("0"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "BL_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

          const detailPromises = formDetailList.map(async (item) => {
            const formDetailData = {
              doc_id: docId,
              so_id: item.soId,
            };

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-bi-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);

          // ทำการ Upload File รูปสลิป - ปรับปรุงใหม่
          if (window.location.pathname === "/bill") {
            // สำหรับหน้า Bill ใช้ multiple upload
            if (multipleSlipImages && multipleSlipImages.length > 0) {
              // const slipFiles = multipleSlipImages.map((image) => image.base64);
              // await uploadMultipleSlips(slipFiles, docId, 14);
            } else if (base64Image) {
              // Backward compatibility สำหรับ single file
              // await uploadMultipleSlips([base64Image], docId, 14);
            }
          } else {
            // สำหรับหน้าอื่นๆ ใช้ single upload เดิม
            if (base64Image) {
              await uploadSlip(base64Image, docId, 14);
            }
          }
        }

        setIsLoading(false);
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดใบขาย");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: formMasterList.compId,
        doc_no: formMasterList.docNo,
        doc_date: formMasterList.docDate,
        doc_due_date: formMasterList.docDueDate,
        doc_status: parseCurrency(formMasterList.docStatus, 10),
        doc_paid_status: parseCurrency(formMasterList.docPaidStatus, 10),
        ar_id: formMasterList.arID,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        bl_total: parseCurrency(soNetTotal ?? totalPrice) || 0,
        bl_dis: receiptDiscount,
        bl_is_vat: isVatChecked
          ? parseCurrency("1", 10)
          : parseCurrency("2", 10),
        bl_vat: parseCurrency(soTotalVat ?? vatAmount) || 0,
        bl_net_total: parseCurrency(grandTotal) || 0,
        doc_is_inv: parseCurrency("0", 10),
        doc_inv_no: formMasterList.docInvNo,
        doc_is_inv_from: formMasterList.docIsInvFrom,
        discount_value: parseCurrency(formMasterList.discountValue || 0),
        discount_type: parseCurrency(selectedDiscountValueType, 10),
        doc_status_paid_type: formMasterList.docStatusPaidType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        doc_bl_receive_date: formatThaiDateUiToDate(
          formMasterList.docBlReceiveDate
        ),
        pay_total: parseCurrency(formMasterList.payTotal),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData(
          "BL_D",
          `WHERE Doc_ID = ${parseCurrency(formMasterList.docId, 10)}`
        );

        const detailPromises = formDetailList.map(async (item) => {
          const formDetailData = {
            doc_id: parseCurrency(formMasterList.docId, 10),
            so_id: item.soId,
          };

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-bi-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        setIsLoading(false);
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        await Promise.all(
          formDetailList.map((formDetail) =>
            Axios.post(
              `${process.env.REACT_APP_API_URL}/api/update-so-paid-complete`,
              {
                doc_status_paid: parseCurrency("2"),
                update_date: formatThaiDateUiToDate(getCreateDateTime()),
                update_by_name: window.localStorage.getItem("name"),
                update_by_id: window.localStorage.getItem("emp_id"),
                doc_no: formDetail.soNo,
                comp_id: window.localStorage.getItem("company"),
                doc_status_paid_type: parseCurrency("4"),
              },
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            )
          )
        );

        setIsLoading(false);
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleRecover = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("1", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        setIsLoading(false);
        callInitialize();
        getAlert(response.data.status, "ส่งกลับแก้ไขสำเร็จ");
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleTax = async () => {
    try {
      const response = await InvoiceHandleSubmit(
        "BI", // BI = ใบวางบิล, SO = ใบขาย
        formMasterList.arID, // arId
        formMasterList.arCode, // arCode
        formMasterList.arName, // arName
        formMasterList.arTaxNo, // arTaxNo
        formMasterList.arAdd1, // arAdd1
        formMasterList.arAdd2, // arAdd2
        formMasterList.arAdd3, // arAdd3
        formMasterList.arProvince, // arProvince
        formMasterList.arZipcode, // arZipcode
        null, // arContact1
        null, // arContact2
        null, // arTel1
        null, // arTel2
        formMasterList.docDate, // docDate
        1, // docFor
        formMasterList.docId, // refDocId
        formMasterList.docNo, // refDoc
        formMasterList.docDate, // refDocDate
        formMasterList.docRemark1, // docRemark1
        isVatChecked // isVat
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const [showPayTypeModal, setShowPayTypeModal] = useState(false);
  const handlePayTypeShow = () => setShowPayTypeModal(true);
  const handlePayTypeClose = async () => {
    setShowPayTypeModal(false);
    setPaymentType({});
    setPaymentAmount({});
    setMultipleSlipImages([]);

    if (mode === "U") {
      await initialize();
    }
  };
  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const checkPayment = async () => {
    setIsLoading(true);
    try {
      const totalPaidAmount =
        (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
        (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
        (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0) +
        (paymentType.fee ? parseCurrency(paymentAmount.fee) : 0) +
        (paymentType.other ? parseCurrency(paymentAmount.other) : 0);

      if (parseCurrency(totalPaidAmount) === 0) {
        getAlert("FAILED", "กรุณาระบุยอดการชำระเงิน");
        setIsLoading(false);
        return;
      }

      await setShowConfirmModal(true);
    } catch (err) {
      getAlert("FAILED", err.message || err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitPayment = async () => {
    try {
      setIsLoading(true);

      // ตรวจสอบค่าว่าเลือกประเภทการชำระเงินหรือยัง
      if (!paymentType) {
        getAlert("FAILED", "กรุณาเลือกประเภทการชำระเงิน");
        setIsLoading(false);
        return; // หยุดการทำงานของฟังก์ชันหากไม่ได้เลือกประเภทการชำระเงิน
      }

      let docPaidStatus;
      const totalPaidAmount =
        (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
        (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
        (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0) +
        (paymentType.fee ? parseCurrency(paymentAmount.fee) : 0) +
        (paymentType.other ? parseCurrency(paymentAmount.other) : 0);

      if (parseCurrency(totalPaidAmount) === 0) {
        getAlert("FAILED", "กรุณาระบุยอดการชำระเงิน");
        setIsLoading(false);
        return;
      }

      if (parseCurrency(totalPaidAmount) < parseCurrency(grandTotal)) {
        docPaidStatus = 1; // ค้างจ่าย
      } else {
        docPaidStatus = 2; // จ่ายครบ
      }

      // ตรวจสอบช่องทางที่ถูกเลือก
      let docStatusPaidType = 6;
      const selectedMethods = Object.keys(paymentType).filter(
        (method) =>
          paymentType[method] && parseCurrency(paymentAmount[method]) > 0
      );

      if (selectedMethods.length === 1) {
        const method = selectedMethods[0];
        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
          fee: 4,
          other: 8,
        };
        docStatusPaidType = paymentTypeMap[method] || 6;
      }

      // เก็บจำนวนยอดการชำระเงินเดิมที่เคยจ่ายไว้ก่อน เอาไว้ตัดสต็อกนะ
      const oldPayTotal = parseCurrency(formMasterList.payTotal);

      // ข้อมูลหลักที่จะส่งไปยัง API (ค่าธรรมเนียมบันทึกที่ BL_H.BL_Service_Charge)
      const feeAmount = paymentType.fee ? parseCurrency(paymentAmount.fee) : 0;
      const formPaidData = {
        doc_status:
          docPaidStatus === 2 ? parseCurrency("5") : parseCurrency("1", 10),
        doc_paid_status: parseCurrency(docPaidStatus),
        doc_status_paid_type: parseCurrency(docStatusPaidType),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
        pay_total: parseCurrency(totalPaidAmount),
        bl_service_charge: parseCurrency(feeAmount),
      };
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-paid`,
        formPaidData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // เพิ่ม Business มาใหม่ By SpriteZadis
        for (const formDetail of formDetailList) {
          // เอาใบขายที่เก็บอยู่ใน BL_D มาหยอดสถานะว่า 'จ่ายแล้ว'
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-so-paid-complete`,
            {
              doc_status_paid: docPaidStatus === 2 ? parseCurrency("3") : parseCurrency("2"),
              update_date: formatThaiDateUiToDate(getCreateDateTime()),
              update_by_name: window.localStorage.getItem("name"),
              update_by_id: window.localStorage.getItem("emp_id"),
              doc_no: formDetail.soNo,
              comp_id: window.localStorage.getItem("company"),
              doc_status_paid_type: parseCurrency("4"), // มันต้องคงเป็นเครดิตตลอดเวลา
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        }

        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
          fee: 4,
          other: 8,
        };

        // formMasterList.docPaidStatus === 1 คือการแก้ไขชำระเงิน
        if (formMasterList.docPaidStatus === "1") {

          const findMaxRecNo = await getData(
            "Tb_Set_Rec_No",
            `1 = 1 ORDER BY RecNo DESC`
          );
          let maxRec = getMaxRecNoForTest(findMaxRecNo);
          await createSetRecNo(maxRec);

          await handleUpdatePayment(oldPayTotal);
        } else {
          // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
          await randomDelay();
          // รันเลข REC ที่ Tb_Set_Rec_No ล่าสุด
          const findMaxRecNo = await getData(
            "Tb_Set_Rec_No",
            `1 = 1 ORDER BY RecNo DESC`
          );
          let maxRec = getMaxRecNoForTest(findMaxRecNo);
          await createSetRecNo(maxRec);
          const formUpdateData = {
            table: "BL_H",
            doc_is_inv: parseCurrency("0", 10),
            doc_inv_no: maxRec,
            doc_is_inv_from: parseCurrency("0", 10),
            doc_bl_receive_date: formatThaiDateUiToDate(getCreateDateTime()),
            where: `WHERE Doc_Id = ${formMasterList.docId}`,
          };
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-invoice`,
            formUpdateData,
            {
              headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
            }
          );
        }

        for (const method of Object.keys(paymentType)) {
          if (paymentType[method] && parseCurrency(paymentAmount[method]) > 0) {
            // Prepare bank fields based on input mode and payment method
            let bank_master_id_val = null;
            let bank_id_val = null;
            let pay_to_acc_no_val = null;
            let pay_to_acc_name_val = null;

            if (method === "transfer" || method === "cheque") {
              if (bankInputMode === "manual" || method === "cheque") {
                bank_master_id_val = bankMasterId || null;
                pay_to_acc_no_val = payToAccNo || null;
                pay_to_acc_name_val = payToAccName || null;
              } else if (bankInputMode === "select") {
                bank_id_val = bankId || null;
              }
            }

            const formPaymentHistoryData = {
              doc_code_id: 14,
              doc_id: parseCurrency(formMasterList.docId),
              pay_type: paymentTypeMap[method],
              pay_amount:
                docStatusPaidType === 6
                  ? parseCurrency(paymentAmount[method])
                  : parseCurrency(totalPaidAmount),
              pay_remark: method === "other" ? (otherRemark || "อื่นๆ") : null,
              pay_datetime: moment(paymentTypeMap[method] === 3 ? chequeDate : payDatetime)
                .utcOffset(7, true)
                .format("YYYY-MM-DD HH:mm:ss.SSS"),
              pay_by: localStorage.getItem("name"),
              pay_to_acc_no: pay_to_acc_no_val,
              pay_to_branch: null,
              pay_to_acc_name: pay_to_acc_name_val,
              pay_cheque_no: paymentTypeMap[method] === 3 ? chequeNo : null,
              pay_cheque_name: paymentTypeMap[method] === 3 ? chequeName : null,
              pay_cheque_branch:
                paymentTypeMap[method] === 3
                  ? chequeBranch || "ธนาคารกสิกรไทย"
                  : null,
              pay_cheque_date:
                paymentTypeMap[method] === 3
                  ? moment(chequeDate)
                    .utcOffset(7, true)
                    .format("YYYY-MM-DD HH:mm:ss.SSS")
                  : null,
              pay_cheque_type: null,
              comp_id: localStorage.getItem("company"),
              bank_master_id: bank_master_id_val,
              bank_id: bank_id_val,
              doc_ref: null,
            };

            // ส่งข้อมูลไปยัง API
            await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
              formPaymentHistoryData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          }
        }

        // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
        const getNewData = await getDataWithComp(
          "API_1301_BL_H",
          `AND Doc_Id = ${formMasterList.docId}`
        );
        if (getNewData && getNewData.length > 0) {
          const data = getNewData[0];
          if (data.Doc_Status_Paid_Type === 6) {
            const getPayHistory = await getData(
              "Pay_History",
              `DocCode_Id = 14 AND Doc_Id = ${formMasterList.docId}`
            );
            if (getPayHistory && getPayHistory.length > 0) {
              for (const pay of getPayHistory) {
                await manageWhArPaymentData(
                  data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                  data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                  data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                  0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                  "AI", // ประเภท เช่น AI/AO
                  parseCurrency(pay.Pay_Amount), // ค่าจำนวนเงิน
                  data.Doc_Id, // ไอดีเอกสาร
                  data.Doc_No, // เลขเอกสาร
                  data.Doc_No, // เลขเอกสารอ้างอิง
                  await setRemarkByPaymentType(parseCurrency(pay.Pay_Type)), // หมายเหตุ
                  parseCurrency("4") // ช่องทางการชำระ
                );
              }
            }
          } else {
            // ปรับยอดเงินเข้า
            await manageWhArPaymentData(
              data.AR_ID, // AR_ID ของลูกค้านั้นๆ
              data.AR_Code, // AR_Code ของสิ่งนั้นๆ
              data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
              0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
              "AI", // ประเภท เช่น AI/AO
              parseCurrency(data.Pay_Total), // ค่าจำนวนเงิน
              data.Doc_Id, // ไอดีเอกสาร
              data.Doc_No, // เลขเอกสาร
              data.Doc_No, // เลขเอกสารอ้างอิง
              await setRemarkByPaymentType(
                parseCurrency(data.Doc_Status_Paid_Type)
              ), // หมายเหตุ
              parseCurrency("4") // ช่องทางการชำระ
            );
          }
        }

        // ทำการ Upload File รูปสลิป - ปรับปรุงใหม่
        if (window.location.pathname === "/bill") {
          // สำหรับหน้า Bill ใช้ multiple upload
          if (multipleSlipImages && multipleSlipImages.length > 0) {
            const slipFiles = multipleSlipImages.map((image) => image.base64);
            await uploadSlip(slipFiles, formMasterList.docId, 14);
          } else if (base64Image) {
            await uploadSlip([base64Image], formMasterList.docId, 14);
          }
        } else {
          // สำหรับหน้าอื่นๆ ใช้ single upload เดิม
          if (base64Image) {
            await uploadSlip(base64Image, formMasterList.docId, 14);
          }
        }

        setIsLoading(false);
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdatePayment = async (oldPayTotal) => {
    try {
      setIsLoading(true);

      // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
      await deleteData(
        "Pay_History",
        `WHERE DocCode_Id = 14 AND Doc_Id = ${formMasterList.docId}`
      );

      // เอายอดเดิมก่อนที่จะแก้ไข มาทำการจ่ายคืนสต็อกก่อน
      const getOldData = await getDataWithComp(
        "API_1301_BL_H",
        `AND Doc_Id = ${formMasterList.docId}`
      );
      if (getOldData && getOldData.length > 0) {
        const data = getOldData[0];

        // ปรับยอดเงินออก
        await manageWhArPaymentData(
          data.AR_ID, // AR_ID ของลูกค้านั้นๆ
          data.AR_Code, // AR_Code ของสิ่งนั้นๆ
          data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
          0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
          "AO", // ประเภท เช่น AI/AO
          parseCurrency(oldPayTotal), // ค่าจำนวนเงิน
          data.Doc_Id, // ไอดีเอกสาร
          data.Doc_No, // เลขเอกสาร
          data.Doc_No, // เลขเอกสารอ้างอิง
          `แก้ไขการชำระเงินใบวางบิล : ${data.Doc_No}`, // หมายเหตุ,
          parseCurrency("4") // ช่องทางการชำระ
        );
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  // ใช้สำหรับปรับสถานะที่เป็น 'ค้างจ่าย' ให้เป็น 'จ่ายครบ' (เฉพาะเช็ค)
  const handleUpdatePaidStatus = async () => {
    try {
      setIsLoading(true);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formUpdateData = {
        doc_paid_status: parseCurrency("2", 10),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-paid-complete`,
        formUpdateData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        setIsLoading(false);
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  // เปิด Modal สำหรับดูรายละเอียดใบขาย
  const [showViewSoModal, setShowViewSoModal] = useState(false);
  const [selectedSoData, setSelectedSoData] = useState(null);
  const handleViewSoClose = () => {
    setShowViewSoModal(false);
    setSelectedSoData(null);

    // ลบ class 'modal-open' จาก body
    document.body.classList.remove("modal-open");

    // ลบ element ที่อาจถูกซ้อน เช่น backdrop ของ Modal
    const backdrops = document.getElementsByClassName("modal-backdrop");
    while (backdrops.length > 0) {
      backdrops[0].parentNode.removeChild(backdrops[0]);
    }
  };
  const handleViewSo = (soData) => {
    setSelectedSoData(soData);
    setShowViewSoModal(true);
  };

  useEffect(() => {
    const totals = formDetailList.reduce(
      (acc, item) => {
        acc.soTotal += parseCurrency(item.itemTotal) || 0;
        acc.soTotalVat += parseCurrency(item.totalVat) || 0;
        acc.soNetTotal += parseCurrency(item.netTotal) || 0;
        return acc;
      },
      { soTotal: 0, soTotalVat: 0, soNetTotal: 0 }
    );

    setSoTotal(totals.soTotal);
    setSoTotalVat(totals.soTotalVat);
    setSoNetTotal(totals.soNetTotal);
  }, [formDetailList]);

  useEffect(() => {
    let discountValue = parseCurrency(formMasterList.discountValue || 0);
    let discountType = String(formMasterList.discountType || "2");
    let receiptDiscountCalc = 0;


    if (discountType === "2") {
      receiptDiscountCalc = (soNetTotal * discountValue) / 100;
    } else if (discountType === "1") {
      receiptDiscountCalc = discountValue;
    }

    setReceiptDiscount(parseCurrency(receiptDiscountCalc.toFixed(2)));
  }, [soNetTotal, formMasterList.discountValue, selectedDiscountValueType, formMasterList.discountType]);

  useEffect(() => {
    setVatAmount(soTotalVat);
    const grand = parseFloat((soNetTotal - receiptDiscount).toFixed(2));
    setGrandTotal(parseCurrency(grand));
  }, [soNetTotal, soTotalVat, receiptDiscount]);

  // Sync computed totals back to formMasterList so any inputs bound to
  // formMasterList show the latest values (useful after add/remove SO)
  useEffect(() => {
    setFormMasterList((prev) => ({
      ...prev,
      blTotal: soNetTotal,
      blDis: receiptDiscount,
      blVat: soTotalVat,
      blNetTotal: grandTotal,
    }));
  }, [soNetTotal, receiptDiscount, soTotalVat, grandTotal]);

  return (
    <>
      <Breadcrumbs
        page={docNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        otherStatusName={statusPaidName}
        otherStatusColour={statusPaidColour}
        otherTypeName={statusPaidTypeName}
        otherTypeColour={statusPaidTypeColour}
        items={[
          { name: "งานบัญชี", url: "/account" },
          { name: name, url: "/bill" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        docIsINV={formMasterList.docIsInv}
        onHandleClick={() => getReport("bi1", docNo)}
        onHandleInvoice1={() => getReport("inv1", formMasterList.docInvNo)}
        onHandleInvoice2={() => getReport("inv2", formMasterList.docInvNo)}
        onHandleInvoice3={() =>
          getReport(
            localStorage.getItem("company") === "1"
              ? "inv_water_receipt"
              : "inv_ice_receipt",
            docNo
          )
        }
        urlImg={slipImage}
        handleUploadSlip={handleUploadSlip}
        base64Image={base64Image}
        setBase64Image={setBase64Image}
        handleUpdateSlip={handleUpdateSlip}
      />
      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div className="body">
          <div class="container-fluid">
            <div className="row mb-1">
              <div className="col-4">
                <DatePicker
                  label="วันที่เอกสาร"
                  name="docDate"
                  value={formMasterList.docDate}
                  onChange={(date) => handleChangeDateMaster(date, "docDate")}
                  disabled={mode === "U"}
                />
              </div>
              <div className="col-4 text-left">
                <div className="d-flex align-items-center">
                  <label>ลูกค้า</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control input-spacing"
                      name="apCode"
                      value={
                        (formMasterList.arCode || "") +
                        " " +
                        (formMasterList.arName || "")
                      }
                      onChange={handleChangeMaster}
                      disabled={true}
                    />
                    <button
                      className="btn btn-outline-secondary"
                      onClick={handleArShow}
                      disabled={mode === "U" ? true : false}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <ArModal
                  showArModal={showArModal}
                  handleArClose={handleArClose}
                  arDataList={arDataList}
                  onRowSelectAr={onRowSelectAr}
                />
              </div>
              <div className="col-4">
                <div className="d-flex">
                  <label>สร้างโดย : </label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.createdByName}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                <div className="d-flex">
                  <label>รายละเอียดเอกสาร : </label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="docRemark1"
                    value={formMasterList.docRemark1 || ""}
                    onChange={handleChangeMaster}
                    disabled={
                      formMasterList.docIsInv === 1 ||
                      formMasterList.docStatus !== 1
                    }
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label>ที่อยู่</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="apAdd1"
                    value={formMasterList.arAdd1 || ""}
                    onChange={handleChangeMaster}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex">
                  <label className="">วันที่สร้าง : </label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.createdDate}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                <div className="d-flex">
                  <label>หมายเหตุธุรการ : </label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="docRemark2"
                    value={formMasterList.docRemark2 || ""}
                    onChange={handleChangeMaster}
                    disabled={
                      formMasterList.docIsInv === 1 ||
                      formMasterList.docStatus !== 1
                    }
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label></label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      (formMasterList.arAdd2 || "") +
                      " " +
                      (formMasterList.arAdd3 || "")
                    }
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                {/* <div className="d-flex">
              <label>วันที่เอกสารอ้างอิง : </label>
              <input
                //type="date"
                type="text"
                className="form-control input-spacing"
                name="refDocDate"
                value={formMasterList.refDocDate || ''}
                disabled={true}
              />
            </div> */}
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label></label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      (formMasterList.arProvince || "") +
                      " " +
                      (formMasterList.arZipcode || "")
                    }
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                {/* <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="whDocRemark"
                value={formMasterList.whDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={isDisabled} />
            </div> */}
                {/* <div className="d-flex">
              <label>จากคลัง : </label>
              <select
                class="form-select"
                value={selectedWarehouseFrom}
                onChange={(e) => handleChangeWarehouse(e.target.value, 'FROM')}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whFromDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Name}
                  </option>
                ))}
              </select>
            </div> */}
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label>เลขที่ภาษี</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.arTaxNo || ""}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                {/* <div className="d-flex">
              <label>ไปคลัง :</label>
              <select
                class="form-select"
                value={selectedWarehouseTo}
                onChange={(e) => handleChangeWarehouse(e.target.value, 'TO')}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whToDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Code} ({warehouse.WH_Name})
                  </option>
                ))}
              </select>
            </div> */}
              </div>
              <div className="col-4">
                {/* <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="whDocRemark"
                value={formMasterList.whDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={false} />
            </div> */}
              </div>
            </div>
          </div>
          <hr />
        </div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col-12">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title">รายละเอียดสินค้า</h4>
                    <button
                      className="btn text-white mx-3"
                      onClick={handleSoShow}
                      style={{
                        backgroundColor: "rgb(239, 108, 0)",
                        whiteSpace: "nowrap",
                        padding: "10px",
                        fontSize: "15px",
                      }}
                      disabled={
                        formMasterList.arID === null ||
                          formMasterList.docIsInv === 1 ||
                          formMasterList.docStatus !== 1 ||
                          (mode === "U" && formMasterList.docPaidStatus !== 0)
                          ? true
                          : false
                      }
                    >
                      <i className="fa fa-plus"></i> เพิ่มรายการ
                    </button>
                    <SoModal
                      showSoModal={showSoModal}
                      handleSoClose={handleSoClose}
                      soDataList={soDataList}
                      onConfirmSoSelection={onConfirmSoSelection}
                      arId={formMasterList.arID}
                      initialSelectedItems={formDetailList}
                    />
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "500px", overflowY: "auto" }}
                    >
                      <table
                        id="basic-datatables"
                        className="table table-striped table-hover"
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center" style={{ width: "3%" }}>
                              #
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              เลขที่ใบขาย
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              วันที่เอกสาร
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "45%" }}
                            >
                              ชื่อลูกค้า
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              รวมราคา
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              VAT
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              รวมสุทธิ
                            </th>
                            <th className="text-center" style={{ width: "2%" }}>
                              View
                            </th>
                            <th className="text-center" style={{ width: "3%" }}>
                              ลบ
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formDetailList.length > 0 ? (
                            [...formDetailList]
                              .sort((a, b) => {
                                const dateA = new Date(a.soDocDate);
                                const dateB = new Date(b.soDocDate);

                                if (dateA - dateB !== 0) {
                                  return dateA - dateB;
                                }

                                return a.soNo.localeCompare(b.soNo, undefined, {
                                  numeric: true,
                                });
                              })
                              .map((item, sortedIndex) => {
                                const originalIndex = formDetailList.findIndex(
                                  (originalItem) =>
                                    originalItem.soId === item.soId &&
                                    originalItem.soNo === item.soNo
                                );

                                return (
                                  <tr key={item.itemId || sortedIndex + 1}>
                                    <td className="text-center">
                                      {sortedIndex + 1}
                                    </td>

                                    <td className="text-center">
                                      <span>{item.soNo || ""}</span>
                                    </td>

                                    <td className="text-center">
                                      <span>
                                        {formatDate(item.soDocDate) || ""}
                                      </span>
                                    </td>

                                    <td className="text-left">
                                      <span>{item.arName || ""}</span>
                                    </td>

                                    <td className="text-end">
                                      <span>
                                        {formatCurrency(item.itemTotal) || 0.0}
                                      </span>
                                    </td>

                                    <td className="text-end">
                                      <span>
                                        {formatCurrency(item.totalVat) || 0.0}
                                      </span>
                                    </td>

                                    <td className="text-end">
                                      <span>
                                        {formatCurrency(item.netTotal) || 0.0}
                                      </span>
                                    </td>

                                    <td className="text-center">
                                      <i
                                        className="fa fa-eye"
                                        style={{
                                          color: "#EF6C00",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => handleViewSo(item)}
                                      ></i>
                                    </td>

                                    <td className="text-center">
                                      <i
                                        className="fa fa-trash"
                                        style={{
                                          color:
                                            formMasterList.docStatus !== 1
                                              ? "gray"
                                              : "red",
                                          cursor:
                                            formMasterList.docStatus !== 1
                                              ? "not-allowed"
                                              : "pointer",
                                          pointerEvents:
                                            formMasterList.docStatus !== 1
                                              ? "none"
                                              : "auto",
                                        }}
                                        onClick={() => {
                                          if (formMasterList.docStatus === 1) {
                                            setRemoveSoIndex(originalIndex);
                                            setShowConfirmRemoveSo(true);
                                          }
                                        }}
                                      ></i>
                                    </td>

                                    {showViewSoModal && selectedSoData && (
                                      <ViewSoModal
                                        showViewSoModal={showViewSoModal}
                                        handleViewSoClose={handleViewSoClose}
                                        mode={"U"}
                                        name={`ใบขายสินค้าเลขที่ ${selectedSoData.soNo}`}
                                        maxDocNo={selectedSoData.soNo}
                                      />
                                    )}
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="9">
                                <center>
                                  <h5>ไม่พบรายการสินค้า</h5>
                                </center>
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td
                              colSpan="4"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              <div className="text-end">
                                <span>รวมราคา</span>
                              </div>
                            </td>
                            <td
                              colSpan="1"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              {/* รวมราคา */}
                              <span
                                className="text-end"
                                style={{ color: "#EF6C00" }}
                              >
                                {formatCurrency(soTotal)}
                              </span>
                            </td>
                            <td
                              colSpan="1"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              {/* VAT */}
                              <span style={{ color: "#EF6C00" }}>
                                {formatCurrency(soTotalVat)}
                              </span>
                            </td>
                            <td
                              colSpan="1"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              {/* รวมราคาสุทธิ */}
                              <span style={{ color: "#EF6C00" }}>
                                {formatCurrency(soNetTotal)}
                              </span>
                            </td>
                            <td colSpan="2"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4">
                        <h4 className="card-title">ส่วนลดท้ายบิล</h4>
                        <div className="row mt-3">
                          <div className="col-3">
                            <div className="d-flex align-items-center">
                              <label className="mr-2 flex-grow-1">ส่วนลดมูลค่า</label>
                            </div>
                          </div>
                          <div className="col-3">
                            <input
                              type="text"
                              className="form-control text-end"
                              name="discountValue"
                              value={formMasterList.discountValue}
                              onChange={handleChangeMaster}
                              onInput={(e) => {
                                if (/^0+/.test(e.target.value)) {
                                  e.target.value = e.target.value.replace(/^0+/, '');
                                  // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                                  if (e.target.value.startsWith(".")) {
                                    e.target.value = "0" + e.target.value;
                                  }
                                }
                              }}
                            />
                          </div>
                          <div className="col-3">
                            <div className="row">
                              <div className="radio-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="2"
                                  checked={selectedDiscountValueType === '2'}
                                  onChange={handleCheckboxChange}
                                  disabled={true}
                                />
                                <label className="form-check-label">%</label>
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-3">
                            <input
                              type="text"
                              className="form-control text-end"
                              name="discountValueTotal"
                              value={receiptDiscount || ''}
                              onChange={handleChangeMaster}
                              disabled={true}
                            />
                          </div> */}
                        </div>
                      </div>
                      <div className="col-4"></div>
                      <div className="col-4">
                        <h4 className="card-title">ยอดท้ายบิล</h4>
                        <div className="row mt-3">
                          <div className="col-12">

                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>รวมราคา</label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{ width: '100px' }}
                                value={formatCurrency(soNetTotal || 0)}
                                disabled={true}
                              />
                            </div>
                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>รวมส่วนลด</label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{ width: '100px' }}
                                value={formatCurrency(receiptDiscount || 0)}
                                disabled={true}
                              />
                            </div>
                            <hr />
                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>
                                <h5>ราคารวมสุทธิ</h5>
                              </label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{
                                  width: "100px",
                                  color: "red",
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                                value={formatCurrency(grandTotal || 0)}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <PaymentModal
                mode={mode}
                show={showPayTypeModal}
                grandTotal={grandTotal}
                paymentType={paymentType}
                setPaymentType={setPaymentType}
                paymentAmount={paymentAmount}
                setPaymentAmount={setPaymentAmount}
                payDatetime={payDatetime}
                setPayDatetime={setPayDatetime}
                handlePayTypeClose={handlePayTypeClose}
                handleUpdatePayment={handleSubmitPayment}
                handleUploadSlip={handleUploadSlip}
                base64Image={base64Image}
                setBase64Image={setBase64Image}
                chequeNo={chequeNo}
                setChequeNo={setChequeNo}
                chequeName={chequeName}
                setChequeName={setChequeName}
                chequeBranch={chequeBranch}
                setChequeBranch={setChequeBranch}
                chequeDate={chequeDate}
                setChequeDate={setChequeDate}
                bankMasterId={bankMasterId}
                setBankMasterId={setBankMasterId}
                bankInputMode={bankInputMode}
                setBankInputMode={setBankInputMode}
                payToAccNo={payToAccNo}
                setPayToAccNo={setPayToAccNo}
                payToAccName={payToAccName}
                setPayToAccName={setPayToAccName}
                bankId={bankId}
                setBankId={setBankId}
                showConfirmModal={showConfirmModal}
                setShowConfirmModal={setShowConfirmModal}
                checkPayment={checkPayment}
                docId={formMasterList.docId}
                docCodeId={14} // 14 คือ DocCode_Id สำหรับ Bill
                multipleSlipImages={multipleSlipImages}
                setMultipleSlipImages={setMultipleSlipImages}
                handleMultipleSlipUpload={handleMultipleSlipUpload}
                handleRemoveSlipImage={handleRemoveSlipImage}
                handleClearAllSlips={handleClearAllSlips}
                isUploadingSlips={isUploadingSlips}
                otherRemark={otherRemark}
                setOtherRemark={setOtherRemark}
              />
            </div>
          </div>
        </div>
      </div>
      <FormAction
        onSubmit={() =>
          parseCurrency(grandTotal) === 0
            ? getAlert("FAILED", "กรุณาเพิ่มรายการ หรือ ใส่จำนวนเงินก่อนบันทึก")
            : handleSubmit()
        }
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        onRecover={handleRecover}
        onApprovedPay={handlePayTypeShow}
        onSubmitTax={handleTax}
        onUpdatePaid={handleUpdatePaidStatus}
        docStatus={formMasterList.docStatus}
        docPaidStatus={formMasterList.docPaidStatus}
        mode={mode}
        setMode={setMode}
        disabled={
          formMasterList.docStatus === 2 ||
            formMasterList.docStatus === 5 ||
            formMasterList.docStatus === 13
            ? true
            : false
        }
        disabledInv={
          formMasterList.docStatus === 1 ||
            formMasterList.docStatus === 5 ||
            formMasterList.docStatus === 13
            ? true
            : false
        }
        disabledPay={
          formMasterList.docStatus === 1 ||
            formMasterList.docStatus === 5 ||
            formMasterList.docStatus === 13
            ? true
            : false
        }
        footer={true}
      />
      {/* Confirm Remove SO Modal */}
      {showConfirmRemoveSo && (
        <div
          className={`modal fade ${showConfirmRemoveSo ? "show" : ""}`}
          tabIndex="-1"
          style={{ display: showConfirmRemoveSo ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">ยืนยันการลบรายการใบขาย</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowConfirmRemoveSo(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>คุณแน่ใจว่าต้องการลบรายการใบขายนี้หรือไม่?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-lg w-25 shadow text-white d-flex align-items-center justify-content-center"
                  style={{ backgroundColor: "#EF6C00", fontSize: "16px" }}
                  onClick={() => {
                    handleRemoveSo(removeSoIndex);
                    setShowConfirmRemoveSo(false);
                  }}
                >
                  ยืนยัน
                </button>
                <button
                  type="button"
                  className="btn btn-lg w-25 shadow text-white"
                  style={{ backgroundColor: "red", fontSize: "16px" }}
                  onClick={() => setShowConfirmRemoveSo(false)}
                >
                  ยกเลิก
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Form;
